import { Loader2 } from "lucide-react";
import { useFamilies } from "../../hooks/useFamilies";
import { useNearViewport } from "../../hooks/useAuthedImage";
import { LoadMoreRow } from "../SessionGallery";
import { FlockHeader } from "./FlockHeader";
import { FamilyGrid, FamilyList } from "./FamilyViews";

const Body = ({ list, view, ctx, sectionKey, filtering }) => {
  if (!list.loaded) {
    return <div className="py-10 grid place-items-center text-muted-foreground"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  }
  if (!list.items.length) {
    return (
      <p data-testid={`flock-empty-${sectionKey}`} className="py-8 text-sm text-muted-foreground">
        {filtering ? "No ducks here match these filters." : "No ducks in this flock yet. Select ducks and use “Move to…” to add them."}
      </p>
    );
  }
  const View = view === "list" ? FamilyList : FamilyGrid;
  return (
    <>
      <View families={list.items} ctx={ctx} sectionKey={sectionKey} />
      <LoadMoreRow shown={list.items.length} total={list.families} hasMore={list.hasMore} loading={list.loadingMore} onMore={list.loadMore} step={12} testId={`flock-load-more-${sectionKey}`} />
    </>
  );
};

// One flock (or Unsorted): its header, and — only while open and on screen — its ducks, 12 families at a time.
// While searching, `matches` = this flock's matching ducks: the header reads "3 of 12".
export const FlockSection = ({ flock, count, matches, open, enabled = true, onToggle, view, filters, filtering, reload, ctx, ...header }) => {
  const [ref, near] = useNearViewport();
  const sectionKey = flock ? flock.id : "unsorted";
  const list = useFamilies({ flock: sectionKey, filters, enabled: enabled && open && near, reload });
  const sectionCtx = flock ? { ...ctx, flock } : ctx;
  return (
    <section ref={ref} data-testid={`flock-section-${sectionKey}`} className="mt-8 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FlockHeader flock={flock} count={matches == null && filtering && list.loaded ? list.total : count} matches={matches} open={open} onToggle={onToggle} {...header} />
      {open && <Body list={list} view={view} ctx={sectionCtx} sectionKey={sectionKey} filtering={filtering} />}
    </section>
  );
};
